import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

// Masked line-by-line reveal for display headings.
export const MaskReveal = ({
  lines = [],
  className = "",
  onLoad = false,
  delay = 0,
  as: Tag = "h2",
}) => {
  const container = {
    hidden: {},
    show: {
      transition: { staggerChildren: 0.12, delayChildren: delay },
    },
  };
  const line = {
    hidden: { y: "110%" },
    show: { y: 0, transition: { duration: 0.9, ease: EASE } },
  };
  const animateProps = onLoad
    ? { initial: "hidden", animate: "show" }
    : {
        initial: "hidden",
        whileInView: "show",
        viewport: { once: true, margin: "-10% 0px" },
      };

  return (
    <Tag className={className}>
      <motion.span variants={container} {...animateProps} className="block">
        {lines.map((l, i) => (
          <span key={i} className="reveal-mask">
            <motion.span variants={line} className="block">
              {l}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
};

// Simple fade-up for blocks.
export const FadeUp = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
